

import '../pages/SettingPageuser.css'
import './EditModalDam.css'
import { useGlobalContext } from "./Context";
import { useDispatch, useSelector } from "react-redux";

import { loginSuccessP } from "../redux/slices/pensSlice";
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import apiService from "../api/ApiService";
import { addComments } from '../redux/slices/commentsSlice';
import { AddStatus } from '../redux/slices/warningSlice';
import { Close } from '@mui/icons-material';
const moment=require('moment-jalaali');


const DeleteComm=({penr,type})=>{
    const {currentComments}=useSelector(state=>state.comments)
    const {openD,closeD,opens}=useGlobalContext();
    const {currentWarings}=useSelector(state=>state.warning)

    
    const dispatch=useDispatch();
    
 
    const deleteCattleComm=async()=>{           
                console.log(penr)
                const res=await apiService.deleteCommentCattle(penr);
                
                
                    const filter=currentComments.filter(item=>{
                        return item.id!==penr
                    })
                    dispatch(addComments(filter))
                    openD()
                    
                
    }
    const deleteSensorComm=async()=>{           
                
        const res=await apiService.deleteCommentSensor(penr);
        
        
            const filter=currentComments.filter(item=>{
                return item.id!==penr
            })
            dispatch(addComments(filter))
            openD()
            
        
}
const deletePenComm=async()=>{           
                
    const res=await apiService.deletePenComment(penr);
    
    
        const filter=currentComments.filter(item=>{
            return item.id!==penr
        })
        dispatch(addComments(filter))
        openD()
        
    
}
const deleteFarmComm=async()=>{           
                
    const res=await apiService.deleteFarmComment(penr);
    
    
        const filter=currentComments.filter(item=>{
            return item.id!==penr
        })
        dispatch(addComments(filter))
        openD()
        
    
}
const deleteOrder=async()=>{
    const res=await apiService.deleteOrderCycle(penr)
    const filter=currentWarings.filter(item=>{
        return item.id!==penr
    })
    dispatch(AddStatus(filter))
    openD()
}

const handleDelete=()=>{
    if(type==='cattle'){
        deleteCattleComm()
    }
    if(type==='cattles'){
        deleteCattleComm()
    }
    if(type==='sensor'){
        deleteSensorComm()
    }
    if(type==='cycle'){
        deleteOrder()
    }
    if(type==='pens'){
        deletePenComm()
    }
    if(type==='farm'){
        deleteFarmComm()
    }
}

    

    return <div onClick={closeD} className={`modal-overlay ${opens&&'show-modal'} `}>
        <div className="editModalDamCon Ani AllFFFF" >
        <div className="closee"><Close className='closee'/></div>

            <div className="editModalDamConHead">
            <PriorityHighIcon fontSize='large'/>

            <h4 >آیا از حذف  مطمئن هستید؟</h4>
            </div>
       
        
        <button className="EditMOdalBtnForm" onClick={handleDelete}>
            تایید
        </button>
        
        </div>
        <div style={{marginTop:'120px'}}> 
        
        </div>
        
        
    </div>
}
export default DeleteComm